import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useContext, useEffect } from "react";
import styled from "styled-components";
import { token } from "./token.js";
import { useZIndex } from "./useZIndex.js";
import { useDropdownContext } from "./context3.js";
import { mergeRefs } from "./mergeRefs.js";
import { ItemContext } from "./itemContext.js";
const Container = forwardRef(({
  children,
  minWidth,
  role = "menu",
  ...props
}, ref) => {
  const zIndex = useZIndex("dropdown");
  const containerRef = useRef(null);
  const {
    dispatch
  } = useDropdownContext();
  const parentId = useContext(ItemContext);
  useEffect(() => {
    return () => {
      dispatch({
        type: "purge-menu-items",
        payload: parentId
      });
    };
  }, [children, dispatch, parentId]);
  return /* @__PURE__ */ jsx(ContainerStyled, {
    $minWidth: minWidth,
    role,
    ref: mergeRefs(ref, containerRef),
    $zIndex: zIndex,
    ...props,
    onMouseLeave: props.onMouseLeave,
    children
  });
});
const ContainerStyled = styled.div.withConfig({
  displayName: "ContainerStyled",
  componentId: "sc-rd9abn-0"
})(["z-index:", ";overflow-y:auto;box-sizing:border-box;min-width:", ";max-width:336px;max-height:calc(36px * 9.5 + ", ");padding:", " 0;border-radius:", ";background:", ";color:", ";box-shadow:", ",", ";&:empty{display:none;}"], (props) => props.$zIndex, (props) => props.$minWidth ? props.$minWidth : `224px`, token.spacing3, token.spacing3, token.radiusBase, token.gray10, token.colorText, token.elevationStatic, token.elevation2);
export {
  Container
};
//# sourceMappingURL=Container.js.map
